import {Typography} from "@mui/material"
import {styled} from "@mui/material/styles"

export const Container = styled("div")`
    position: fixed;
    bottom: 0rem;
    right: 0rem;
    width: 100%;
    padding: 0rem;
    padding-top: 0rem;
    border-radius: 0rem;
    background-color: ${({theme}) => theme.uxfabric.background.paper};
`

export const StyledTitle = styled(Typography)`
    padding-bottom: 0rem;
    margin: auto;
`

export const Header = styled("div")`
    display: flex;
    ${({theme}) => `
      background-color: ${theme.uxfabric.background.paper};
    `};
    padding: 0.7rem;
    padding-bottom: 0.7rem;
`

export const UnstyledButton = styled("button")`
    background: none;
    color: inherit;
    border: none;
    padding: 0;
    font: inherit;
    cursor: pointer;
    outline: inherit;
    color: ${({theme}) => theme.uxfabric.text.primary};
    text-decoration: underline;
`

export const BodyContainer = styled("div")`
    text-align: center;
    padding: 1rem;
`

export const BodyText = styled(Typography)`
    display: inline;
    font-size: 0.875rem;
    margin: 0;
`
